import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { CompanyApi } from '@app/services/company-api';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/savedproduct';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { SavedProductInterface } from '@app/interface/savedproduct';
import { SavedProductsApi } from '@app/services/savedproducts-api.service';
import { MatIconModule } from '@angular/material/icon';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { ToastService } from '@app/services/toast.service';

@Component({
  selector: 'izy-new-savedproduct',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatIconModule,
    BackHeaderComponent,
  ],
  templateUrl: './new-savedproduct.component.html',
  styleUrl: './new-savedproduct.component.scss',
})
export class NewSavedproductComponent {
  private toast = inject(ToastService);
  typeOptions: TypeOptions[] = [
    { code: 'SERVIZIO', name: 'Servizio' },
    { code: 'PRODOTTO', name: 'Prodotto' },
  ];

  constructor(
    private SavedProductApi: SavedProductsApi,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  newSavedProduct: Partial<SavedProductInterface> = {
    id: 1,
    name: '',
    units: '',
    type: 'SERVIZIO',
    unit_price: 0,
    description: '',
    iva_percentage: 0,

    organization_id: 1,
  };

  addNewSavedProduct(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // set organization_id
    this.newSavedProduct.organization_id = organization_id;

    // validate required fields
    console.log(
      !this.newSavedProduct.organization_id || !this.newSavedProduct.id,
    );
    console.log(this.newSavedProduct);

    this.SavedProductApi.createSavedProduct(
      organization_id,
      this.newSavedProduct,
    ).subscribe({
      next: (createdSavedProduct: SavedProductInterface) => {
        // this.companySource.data = [...this.companySource.data, createdCompany];
        this.showSuccessMessage(
          `${createdSavedProduct.name} aggiunto con successo!`,
        );
        console.log(createdSavedProduct);
        // this.resetForm(form);
      },
      error: (err: any) => {
        console.error('Error creating company:', err);
        this.showErrorMessage('Errore. Per favore riprova.');
      },
    });
  }

  navigateToSavedProducts() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/savedproducts_table`]);
  }

  onSubmit() {
    // Handle form submission first
    this.addNewSavedProduct();

    // Then debounce the navigation
    setTimeout(() => {
      this.navigateToSavedProducts();
    }, 300);
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
